// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"14":"4860889f","940":"28056353"}[chunkId] + ".css";
};